module.exports = __webpack_public_path__ + "static/media/css3.754ff252.svg";